import React from 'react';
 
interface ErrorBoundaryState {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }
 
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // 你可以将错误信息上报给服务器
    console.error("ErrorBoundary caught an error", error, info);
    this.setState({ hasError: true });
  }
 
  render() {
    if (this.state.hasError) {
      // 你可以在这里渲染一个自定义的错误信息组件
      return <h1>Something went wrong.</h1>;
    }
    return this.props.children;
  }
}
 
export default ErrorBoundary;